import { types as t } from '@invisr/mobx-state-tree'

export default t.model('Auditable', {
  lastModified: t.maybeNull(t.number),
  lastModifiedBy: t.maybeNull(t.string)
})
